import { useTranslation } from "react-i18next";
import styled from "styled-components";
import type { RestReceipt } from "@KassaroAB/shared/types/receipt";
import { FiscalizationType } from "@KassaroAB/shared/types/enums/FiscalizationType";
import { SectionTitle } from "../../../components/SectionTitle";
import colors from "@styling/colors";
import { spacing } from "@styling/sizing";
import { fontSizes } from "@styling/fonts";

const Section = styled.section`
  display: flex;
  flex-direction: column;
  gap: ${spacing.x1}px;
`;

const Divider = styled.hr`
  border: none;
  border-top: 1px solid ${colors.border};
  margin: 0;
`;

const MetaGrid = styled.div`
  display: grid;
  grid-template-columns: auto 1fr;
  gap: ${spacing.x05}px ${spacing.x2}px;
  font-size: ${fontSizes.small}px;
`;

const MetaLabel = styled.span`
  color: ${colors.textMuted};
`;

const MetaValue = styled.span`
  color: ${colors.text};
`;

interface ReceiptFiscalizationInfoProps {
  receipt: RestReceipt;
}

export const ReceiptFiscalizationInfo = ({ receipt }: ReceiptFiscalizationInfoProps) => {
  const { t } = useTranslation();

  if (!receipt.fiscalization) {
    return null;
  }

  if (receipt.fiscalization.type !== FiscalizationType.SWEDEN) {
    return null;
  }

  return (
    <>
      <Divider />
      <Section>
        <SectionTitle>{t("receiptsView.detail.fiscalization")}</SectionTitle>
        <MetaGrid>
          <MetaLabel>{t("receiptsView.detail.fiscalizationCashRegister")}</MetaLabel>
          <MetaValue>{receipt.fiscalization.cashRegisterDesignation}</MetaValue>
          <MetaLabel>{t("receiptsView.detail.fiscalizationControlUnit")}</MetaLabel>
          <MetaValue>{receipt.fiscalization.controlUnitProductionNumber}</MetaValue>
        </MetaGrid>
      </Section>
    </>
  );
};
